<div class="mb-8">
  <app-form-title-with-subtitle>
    <span title>Przypomnij hasło</span>
    <span subtitle>Przypomnij hasło i odzyskaj dostęp do swojego konta</span>
  </app-form-title-with-subtitle>
</div>

<div class="mb-8">
  <app-alerts />

  @if (isFormVisible()) {
    <app-remind-password-form
      (submitClickEvent)="handleSubmitClickEvent($event)" />
  }
</div>

<div class="text-center">
  <ng-content select="[sign-in-slot]" />
</div>
